export const forBusiness_apparel_eCommerce = [
	{
		icon: '🚀',
		subtitle: 'eCommerceData_subtitle1',
	},
	{
		icon: '👠',
		subtitle: 'eCommerceData_subtitle2',
	},
	{
		icon: '✨',
		subtitle: 'eCommerceData_subtitle3',
	},
];
